import { useNavigate } from "react-router-dom";

import { LogOut } from "lucide-react";

import { setGlobalAuthChecked } from "~/components/layout/utils/authState";
import { SidebarMenuButton } from "~/components/ui/sidebar";
import { useToast } from "~/components/ui/use-toast";
import { supabase } from "~/integrations/supabase/client";
import { useProfileStore } from "~/store/profileStore";

export function LogoutButton() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { clearProfile } = useProfileStore();

  // Handle logout functionality with comprehensive error handling
  const handleLogout = async () => {
    try {
      // First clear all local storage related to authentication
      localStorage.clear(); // Clear all localStorage items

      // Clear profile state
      clearProfile();

      // Reset global auth state
      setGlobalAuthChecked(false);

      // Try to sign out from Supabase, but don't wait for it to complete
      // This ensures we always log out locally even if Supabase has issues
      supabase.auth.signOut().catch((e) => {
        console.warn("Non-critical error during signOut:", e);
      });

      // Show success message
      toast({
        title: "Sesión cerrada",
        description: "Has cerrado sesión correctamente",
      });

      // Navigate to login page
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Error during logout process:", error);

      // Ensure we clear all data even if there was an unexpected error
      localStorage.clear();
      clearProfile();
      setGlobalAuthChecked(false);

      // Show message
      toast({
        title: "Aviso",
        description:
          "La sesión ha sido cerrada. Redirigiendo al inicio de sesión.",
      });

      // Navigate to login page
      navigate("/login", { replace: true });
    }
  };

  return (
    <SidebarMenuButton
      variant="outline"
      onClick={handleLogout}
      className="w-full transition-all hover:border-red-200 hover:bg-red-50 hover:text-red-500 dark:hover:bg-red-950"
    >
      <LogOut size={16} />
      <span>Cerrar Sesión</span>
    </SidebarMenuButton>
  );
}
